module.exports = __webpack_public_path__ + "img/pp-24.b48a8812.jpg";